export enum VideoUploadStatus {
	READY = "ready",
	NO_FILE = "no_file",
	UPLOADING = "uploading",
}

export enum AnalysisStatus {
	ANALYZED = "analyzed",
	REQUESTED = "requested",
	REJECTED = "rejected",
}

export enum AnalysisType {
	MAX = 11,
	DEFAULT_PRIORITY_DISCOVER = 11,
	DEFAULT_PRIORITY_ELITE = 5,
}
